import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MODAL_DATA } from 'src/app/helpers/modal.tokens';

@Component({
  selector: 'app-change-project-checkin-start-date',
  templateUrl: './change-project-checkin-start-date.component.html',
  styleUrls: ['./change-project-checkin-start-date.component.scss']
})
export class ChangeProjectCheckinStartDateComponent implements OnInit {
  today = new Date();
  selectedStartDateOption!: 'now' | 'custom';
  selectedStartDate!: Date;

  constructor(
        @Inject(MODAL_DATA) public data: any,
        private dialogRef: MatDialogRef<any>) {
  }

  ngOnInit(): void {
    this.selectedStartDateOption = this.data.selectedStartDateOption ?? 'now';
    this.selectedStartDate = this.data.selectedStartDate ?? new Date();
  }

  closeModal(button: any): void {
    this.dialogRef.close({
      btnValue: button.value,
      selectedStartDateOption: this.selectedStartDateOption,
      selectedStartDate: this.selectedStartDate
    });
  }

}
